import { useEffect } from 'react';
var useFocus = function (_a) {
    var isFocused = _a.isFocused, ref = _a.ref;
    useEffect(function () {
        if (isFocused && ref.current) {
            ref.current.focus();
        }
    }, [isFocused]);
};
export default useFocus;
